import styled from 'styled-components';

export default styled.div`
  width: 100%;
  height: 100%;

  > h2 {
    flex: 0 0 auto;

    color: ${props => props.theme.palette.primary.main};
    font-size: 2.4rem;
    font-weight: 400;
  }

  > .selection {
    display: flex;
    align-items: center;

    padding-top: 2rem;

    > .phone {
      flex: 0 0 auto;

      padding-right: 3rem;

      min-width: 30rem;
    }

    > .view {
      flex: 0 0 auto;
    }
  }

  > .size {
    padding-top: 2rem;
  }
`;
